import * as React from 'react';
import Grid from '@mui/material/Grid';
import { TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { validatePhone } from '../../utils/regex/Regex';
import { initTopupData } from '../../utils/object/Topup';
import CardMoney from './CardMoney';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: ' 300px',
        paddingRight: '300px'
      },
    },
  };
});

const titleStyle = { textAlign: 'center' };
const marginStyle = { mt: 2 };
const textWidth = { maxWidth: '400px' };

export default function Input() {
  const classes = useStyles();
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  const [phoneErrorText, setPhoneErrorText] = React.useState('');
  const [value, setValue] = React.useState(initTopupData('', ''))

  const handleChangePhone = (event) => {
    let value = event.target.value;
    let Data = handleValidatePhone(value);
    setValue(Data);
  }
  function handleValidatePhone(phone) {
    let result = validatePhone(phone)
    let Data;
    if (!result) {
      Data = {
        ...value,
        phone: phone,
        isPhoneError: true
      };
      setValue(Data);
      setPhoneErrorText("Error Phone Format");
    } else {
      Data = { ...value, phone: phone, isPhoneError: false };
      setValue(Data);
      setPhoneErrorText("");
    }
    return Data;
  }
  console.log(
    value.phone
  )

  return (
    <React.Fragment>
      <Typography variant="h3" gutterBottom sx={titleStyle}>Multi-network (Viettel, Mobifone, Gmobile...)</Typography>
      <Grid container spacing={3} sx={marginStyle} justifyContent="center" alignItems="center" className={classes.gridContainer} >
        <Grid item xs={12} sx={titleStyle}>
          <TextField
            fullWidth
            variant="standard"
            label="Enter Phone number"
            onChange={handleChangePhone}
            error={value.isPhoneError}
            value={value.phone}
            helperText={phoneErrorText}
            sx={textWidth}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={marginStyle} justifyContent="center" alignItems="center" className={classes.gridContainer} >
        <Grid item xs={12} sx={titleStyle}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: `${matchDownSM ? '1' : '3'}` }}>
            Par value 
          </Typography>
        </Grid>
        <Grid item xs={12} sx={titleStyle}>
          <CardMoney />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}